import { Ng2StateDeclaration } from "@uirouter/angular";
import { Home } from "./home.component";

export const homeState: Ng2StateDeclaration = {
    name: "app.home",
    url: "/home",
    views: {
        "main-view@app": {
            component: Home
        }
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/home/home.states.ts